import { render, staticRenderFns } from "./LegacyWorkspace.vue?vue&type=template&id=8c597fac"
import script from "./LegacyWorkspace.vue?vue&type=script&lang=js"
export * from "./LegacyWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports